import { type OperationResult } from 'urql';

import { type CustomerQuery } from '../graphql/customer.generated';

// ─── Types ───────────────────────────────────────────────────────────────────

export type AuthContext = {
  currentCustomer: CurrentCustomerContextData;
  hasLoggedOut: boolean;
  isFirstAuthAttempt: boolean;
  postLoginRedirectHref?: string;
  sessionError?: Error;
  sessionFailureCount: number;
  sessionRetryAt?: number;
};

export type CurrentCustomerContextData =
  | NonNullable<OperationResult<CustomerQuery, Record<string, unknown>>['data']>['currentCustomer']
  | null;

export type SessionData = {
  isLoggedIn: boolean;
};

export type StoreCurrentCustomerDataParams = {
  currentCustomer: CurrentCustomerContextData;
};

export type StorePostLoginRedirectHrefParams = {
  postLoginRedirectHref?: string;
};

export type SessionFailureParams = {
  error: unknown;
};

export type CheckIfSessionIsLoggedInParams = {
  isLoggedIn: boolean;
};
